//import showloaderjs from '../services/watches'
export const TimeRangesConfig = {
    D: [
        {range: '3M', toolTip: '3 Months of Visible Data'},
        {range: '6M', toolTip: '6 Months of Visible Data'},
        {range: '1Y', toolTip: '1 Year of Visible Data'},
        {range: '2Y', toolTip: '1 Year of Visible Data'},
        {range: '5Y', toolTip: '5 Year of Visible Data'},
    ],
    W: [
        {range: '1Y', toolTip: '1 Year of Visible Data'},
        {range: '2Y', toolTip: '2 Year of Visible Data'},
        {range: '5Y', toolTip: '5 Year of Visible Data'},
        {range: '10Y', toolTip: '10 Year of Visible Data'},
        {range: '20Y', toolTip: '20 Year of Visible Data'},
    ],
    M: [
        {range: '5Y', toolTip: '5 Year of Visible Data'},
        {range: '10Y', toolTip: '10 Year of Visible Data'},
        {range: '25Y', toolTip: '25 Year of Visible Data'},
        {range: '50Y', toolTip: '50 Year of Visible Data'},
    ],
    MIN1: [
        {range: '1D', toolTip: '1 Day of Visible Data'},
        {range: '5D', toolTip: '1 Day of Visible Data'},
        {range: '15D', toolTip: '15 Days of Visible Data'},
        // {range: '1M', toolTip: '1 Months of Visible Data'},
        // {range: '3M', toolTip: '3 Months of Visible Data'},
        // {range: '6M', toolTip: '6 Months of Visible Data'},
    ],
    MIN5: [
        {range: '1D', toolTip: '1 Day of Visible Data'},
        {range: '5D', toolTip: '1 Day of Visible Data'},
        {range: '15D', toolTip: '15 Days of Visible Data'},
        {range: '1M', toolTip: '1 Months of Visible Data'},
        // {range: '3M', toolTip: '3 Months of Visible Data'},
        // {range: '6M', toolTip: '6 Months of Visible Data'},
    ],
    MIN15: [
        {range: '1D', toolTip: '1 Day of Visible Data'},
        {range: '5D', toolTip: '1 Day of Visible Data'},
        {range: '15D', toolTip: '15 Days of Visible Data'},
        {range: '1M', toolTip: '1 Months of Visible Data'},
        // {range: '3M', toolTip: '3 Months of Visible Data'},
        // {range: '6M', toolTip: '6 Months of Visible Data'},
    ],
    MIN30: [
        {range: '5D', toolTip: '1 Day of Visible Data'},
        {range: '15D', toolTip: '15 Days of Visible Data'},
        {range: '1M', toolTip: '1 Months of Visible Data'},
        {range: '3M', toolTip: '3 Months of Visible Data'},
        // {range: '6M', toolTip: '6 Months of Visible Data'},
    ],
    H1: [
        {range: '15D', toolTip: '15 Days of Visible Data'},
        {range: '1M', toolTip: '1 Months of Visible Data'},
        {range: '3M', toolTip: '3 Months of Visible Data'},
        {range: '6M', toolTip: '6 Months of Visible Data'},
        {range: '1Y', toolTip: '1 Year of Visible Data'},
        // {range: '2Y', toolTip: '2 Year of Visible Data'},
        // {range: '2Y', toolTip: '25 Year of Visible Data'},
        // {range: '5Y', toolTip: '50 Year of Visible Data'},
    ],
    H2: [
        {range: '1M', toolTip: '1 Months of Visible Data'},
        {range: '3M', toolTip: '3 Months of Visible Data'},
        {range: '6M', toolTip: '6 Months of Visible Data'},
        {range: '1Y', toolTip: '1 Year of Visible Data'},
        // {range: '2Y', toolTip: '2 Year of Visible Data'},
    ],
    H4: [
        {range: '1M', toolTip: '1 Months of Visible Data'},
        {range: '3M', toolTip: '3 Months of Visible Data'},
        {range: '6M', toolTip: '6 Months of Visible Data'},
        {range: '1Y', toolTip: '1 Year of Visible Data'},
        // {range: '2Y', toolTip: '2 Year of Visible Data'},
        // {range: '5Y', toolTip: '50 Year of Visible Data'},
    ],
};